import { isObj } from 'lib/util'

type TranslationMDOptions = {
  ns: string,
  key: string,
  defaultValue: string,
  [key: string]: any
  md?: boolean,
}

type ToastAction = {
  label: string,
  handler: Function,
}

export type ToastOptions = {
  message: TranslationMDOptions
  description?: TranslationMDOptions,
  duration?: number,
  severity?: 'info' | 'success' | 'warning' | 'error' | 'loading'
  close?: boolean,
  action?: ToastAction,
}

/**
 * Requests the display of a toast.
 *
 * @param module  current module
 * @param options toast configuration
 */
const showToast = async (module: Gaia.AppModule.Spec, options: ToastOptions) => {
  const intl = module[G.ADAPTER][G.INTL]
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const { message, description, ...restOptions } = options

  const translatedMessage = isObj(message) && typeof message === 'object'
    ? intl._t(message.key, { ...message, _key: message.key })
    : message

  const translatedDescription = isObj(description) && typeof description === 'object'
    ? intl._t(description.key, { ...description, _key: description.key })
    : description

  eventBus.dispatch(eventBus.type(G.DATA, G.UPDATE), {
    ...restOptions,
    message: translatedMessage,
    description: translatedDescription,
  })
}

export default showToast
